import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { IIndicator, IndicatorStatus } from './';

const statusClasses: Record<IndicatorStatus, string> = {
  active: 'border-black dark:border-white',
  inactive: 'border-transparent',
};

export function Indicator(props: IIndicator & HTMLAttributes<HTMLElement>) {
  const {
    className,
    classNameInner = '',
    status,
    index,
    action,
    duration,
  } = props;
  const doClick = (e) => {
    action(e);
  };

  const animationDuration = 'duration-[' + duration + 'ms]';

  return (
    <span
      className={cn(
        className,
        typeof duration === 'undefined'
          ? 'duration-[2000ms]'
          : animationDuration,
        status ? statusClasses[status] : 'border-transparent',
        'm-4 border-4 w-4 p-0.5 h-4 rounded-full flex hover:cursor-pointer',
      )}
      key={index}
      data-page={index}
      onClick={action ? doClick : null}
    >
      <span
        className={cn(
          classNameInner,
          'w-1 h-1 bg-black dark:bg-white inline-block rounded-full hover:cursor-pointer',
        )}
        data-page={index}
      ></span>
    </span>
  );
}
